import type { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Typography } from '@mui/material';

import { PassengerBookingView } from '@mopla/data-models';
import {
	checkIsBookingCancelled,
	checkIsPassedBooking,
	checkIsSchoolCancellationBlocked,
	isLBTItinerary,
} from '@mopla/utils';

import { MplButton } from '../../../atoms/MplButton';
import { SchoolCancellationDeadlineMessage } from '../../../molecules/SchoolCancellationDeadlineMessage/SchoolCancellationDeadlineMessage';

import { CancelButtonWrapper } from './ui/styled';

interface CancelButtonProps {
	onClick: () => void;
	bookedItinerary: PassengerBookingView;
}

export const CancelButton: FC<CancelButtonProps> = ({
	onClick,
	bookedItinerary,
}) => {
	const { t } = useTranslation('tickets');
	const isCancelledTrip = checkIsBookingCancelled(bookedItinerary);
	const isPassedTrip = checkIsPassedBooking(bookedItinerary);
	const isLBTRide = isLBTItinerary(bookedItinerary.itinerary);

	/** School (RMBLS) rides can only be cancelled in-app up to 1h before
	 *  departure. Within that window, hide the cancel action and explain why. */
	if (checkIsSchoolCancellationBlocked(bookedItinerary)) {
		return (
			<CancelButtonWrapper>
				<SchoolCancellationDeadlineMessage dataTestid="cancelButton-schoolCancellationDeadline-message" />
			</CancelButtonWrapper>
		);
	}

	return (
		<CancelButtonWrapper>
			{!isLBTRide && (isCancelledTrip || isPassedTrip) && (
				<Typography variant="body2">{t('text.hide_booking')}</Typography>
			)}
			<MplButton
				variant="outlined"
				onClick={onClick}
				data-testid="savedTicket-cancelBooking-button"
			>
				{isLBTRide || isCancelledTrip || isPassedTrip
					? t('button.remove_ride')
					: t('button.cancel_booking')}
			</MplButton>
		</CancelButtonWrapper>
	);
};
